import { Navigate } from 'react-router-dom'
import { hasToken } from '@/utils/token'

interface LoginGuardProps {
  children: React.ReactElement
}

// 登录页守卫：已登录则跳转首页，未登录则显示登录页
// 必须在渲染时动态检测 token（不能在路由创建时静态判断，否则退出登录后无法正确跳转）
const LoginGuard = ({ children }: LoginGuardProps) => {
  if (hasToken()) {
    return <Navigate to="/" replace />
  }
  return children
}

export { LoginGuard }
export default LoginGuard
